import { z } from 'zod'

export const paramsSchema = z.object({
  cottageId: z.string(),
  eventType: z
    .enum([
      'card_viz',
      'search_card_viz',
      'cottage_website',
      'cottage_phone',
      'cottage_recommendation',
      'cottage_bookmark',
      'rentunit_search',
    ])
    .nullable(),
})

export type paramsType = z.infer<typeof paramsSchema>
